import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/calm-cards-wave-orbs.css';
import App from './App';
import { readAmplitudeCoeff, applyAmplitudeCoeff } from './utils/animationSettings';

// Коэффициент амплитуды анимаций задаётся через URL: ?amp=<число> (алиас ?amplitude=).
// Значение не ограничено и влияет на анимацию элементов и плеера везде.
applyAmplitudeCoeff(readAmplitudeCoeff());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

